<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    created(){
      let auth = JSON.parse(localStorage.getItem('auth')) || {}
      this.$store.commit('AUTH', auth)
    }
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    background: #f6f6f6;
  }

  ol,
  ul,
  li {
    list-style: none;
  }

  a,
  u {
    text-decoration: none;
    color: #333;
  }

  i,
  span,
  p,
  u,
  a,
  div {
    font-style: normal;
    /* text-align: left; */
  }

  .clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  }

  .hr {
    border-bottom: 1px solid #F0F0F0;
  }

  .select .el-cascader-node {
    padding: 0 30px 0 15px;
  }

  .select .el-icon-check::before {
    display: none;
  }

  .select .el-cascader-node.in-active-path, .select .el-cascader-node.is-active, .select .el-cascader-node.is-selectable.in-checked-path {
    color: #FF6F28;
  }
  /* 日历表 */
  .el-date-table td.end-date span,.el-date-table td.start-date span{
    background-color: #FF5C00;
  }
  .el-date-table td span{
    text-align: center;
  }
  .el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div{
    background-color: #FFF2EB;
  }
  .el-date-table td.available:hover{
    color: #FF6F28;
  }
  .el-picker-panel__shortcut:hover{
    color: #FF6F28;
  }
  .el-date-range-picker__content .el-date-range-picker__header div{
    text-align: center;
  }
  .el-date-table td.today span{
    color: #FF5C00;
  }
  /* 日历表(单个) */
  .el-date-table td.current:not(.disabled) span{
    background-color: #FF5C00;
  }
  .el-date-editor .el-range__close-icon{
    display: none;
  }

  /* 火狐滚动条 */
  * {
    scrollbar-color: #dddee0 #FFFFFF;
    scrollbar-width: thin;
  }

  * ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  /*滚动条的轨道*/
  * ::-webkit-scrollbar-track {
    background-color: #FFFFFF;
  }
  /*滚动条里面的小方块，能向上向下移动*/
  * ::-webkit-scrollbar-thumb {
    background-color:#dddee0;
    border-radius: 5px;
    border: 1px solid #F1F1F1;
    box-shadow: inset 0 0 6px #bebebe;
  }
  * ::-webkit-scrollbar-thumb:hover {
    background-color:#c7c9cc;
  }
  * ::-webkit-scrollbar-thumb:active {
    background-color:#c7c9cc;
  }
  /*边角，即两个滚动条的交汇处*/
  * ::-webkit-scrollbar-corner {
    background-color: #FFFFFF;
  }
</style>